import React from 'react'
import PropTypes from 'prop-types'
import { Flex, Text, CloseButton } from 'pcln-design-system'
import { StyledModal, SEARCH_DROPDOWN } from './MobileModal.styles'
import { ChangeSearchWrapper } from '../ChangeSearchWrapper/ChangeSearchWrapper'

const MobileModal = ({ toggleIsOpen, isOpen, ...props }) => (
  <StyledModal
    isOpen={isOpen}
    dialogAnimation={SEARCH_DROPDOWN}
    verticalAlignment='top'
    imgMode
    width='100%'
    zIndex={1000}
  >
    <Flex alignItems='center' px={3} pt={3}>
      <Text fontSize={4}>Edit Search</Text>
      <CloseButton
        data-testid='SEARCH_MODAL_CLOSE'
        color='primary.base'
        onClick={toggleIsOpen}
        size={32}
        aria-label='close'
        ml='auto'
      />
    </Flex>
    <ChangeSearchWrapper {...props} />
  </StyledModal>
)

MobileModal.propTypes = {
  toggleIsOpen: PropTypes.func,
  isOpen: PropTypes.bool,
  tripType: PropTypes.string,
  setTripType: PropTypes.func,
  cabinClass: PropTypes.string,
  setCabinClass: PropTypes.func,
  passengers: PropTypes.object,
  setPassengers: PropTypes.func,
  useFlexDates: PropTypes.bool,
  setUseFlexDates: PropTypes.func,
  tripSlices: PropTypes.array,
  setTripSlices: PropTypes.func,
  validationError: PropTypes.func,
  displayFlexibleDatesCheckbox: PropTypes.bool,
  airports: PropTypes.object,
  setAirports: PropTypes.func,
}

export { MobileModal }
